import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Navigate } from '@ngxs/router-plugin';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class IsSignedGuard implements CanActivate {
  private loginPath = 'login';
  private homePath = 'home';
  private monitorPath = 'monitor'; 
  
  constructor(
    private store: Store,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let loginUrl = `/${this.loginPath}`;
    let homeUrl = `/${this.homePath}`;
    let isLoginPage = state.url === loginUrl;
    let isMonitorPage: boolean = state.url.indexOf(this.monitorPath) >= 0; 

    if (isMonitorPage) {
      loginUrl = `/${this.monitorPath}/${this.loginPath}`;
      homeUrl = `/${this.monitorPath}/${this.homePath}`;
      isLoginPage = state.url === loginUrl;
    }

    const isAuthenticated =
      this.authenticationService.getTokenFromLocalStorage() != undefined;

    if (isAuthenticated && isLoginPage) {
      this.store.dispatch(new Navigate([homeUrl]));
      return false;
    } else if (!isAuthenticated && !isLoginPage) {
      this.store.dispatch(new Navigate([loginUrl]));
      return false;
    } else if (isAuthenticated && isMonitorPage){
      this.store.dispatch(new Navigate([homeUrl]));
      return false;
    }

    return true;
  }
}
